import { Box, Typography } from "@mui/material";
import type { ReactNode } from "react";

/**
 * 標籤放在欄位上方而不是用 MUI 的浮動標籤，跟登入頁（`LoginPage`）同一套
 * 理由：中性設計語言裡浮動標籤那個縮小動畫太像 Material 的招牌動作，換皮
 * 後會突兀；標籤在上方也讓欄位空著與有值時一樣高，表單不會跳動。
 *
 * 原本每個表單頁各自複製一份，料號的表單也要用才抽出來共用。
 */
export function FormField({
  id,
  label,
  children,
}: {
  id: string;
  label: string;
  children: ReactNode;
}) {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.875 }}>
      <Typography component="label" htmlFor={id} variant="subtitle2" color="text.secondary">
        {label}
      </Typography>
      {children}
    </Box>
  );
}
